module.exports = __webpack_public_path__ + "img/player_turn_007.0e1760ec.png";